import { render, staticRenderFns } from "./shuxing.vue?vue&type=template&id=e8014142&scoped=true&"
import script from "./shuxing.vue?vue&type=script&lang=ts&"
export * from "./shuxing.vue?vue&type=script&lang=ts&"
import style0 from "./shuxing.vue?vue&type=style&index=0&id=e8014142&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8014142",
  null
  
)

export default component.exports